import { CHARGES_ACCOUNT_TYPE_ENUM } from '@/enums/charges-account-type.enum'
import BANKS_ENUM from '@/utils/banks.utils'
import MathManager from '@/utils/math-manager.utils'

class ConfirmBankDetailsManager {
  data
  constructor (data) {
    this.data = data
  }

  get () {
    const { bank, type, amount, totalAmount } = this.data
    return {
      ...this.data,
      bank: BANKS_ENUM[bank],
      type: `recipients.create.type_${
        CHARGES_ACCOUNT_TYPE_ENUM[type.toUpperCase()]
      }`,
      amount: `R$ ${MathManager.formatCurrencyBRL(amount)}`,
      totalAmount: `R$ ${MathManager.formatCurrencyBRL(totalAmount)}`
    }
  }
}
export default ConfirmBankDetailsManager
